import React from 'react';
import { useNavigate } from 'react-router-dom';

const StartChoices = () => {
  const navigate = useNavigate();

  return (
    <div className="start-choices">
      <div className="start-choices-inner">
        <h1 className="start-choices-title">What would you like to do today?</h1>
        <div className="start-choices-grid">
          <button
            className="start-card start-card-permit"
            onClick={() => navigate('/dashboard')}
          >
            <h2 className="start-card-title">Permit applications</h2>
            <p>Submit and track permit applications.</p>
          </button>
          <button
            className="start-card start-card-appeal"
            onClick={() => navigate('/appeal')}
          >
            <h2 className="start-card-title">Appeal assessment</h2>
            <p>Compare your assessed value against recent sales comps.</p>
          </button>
          <button
            className="start-card start-card-report"
            onClick={() => navigate('/report-type')}
          >
            <h2 className="start-card-title">Report an issue</h2>
            <p>Report an issue with a private/public property.</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartChoices;

